import { AI_QUOTA_USAGE_STATUS, useAIQuota } from 'core/hooks/useAIQuota';

function useIsAIQuotaExhausted(): boolean {
  const { usage } = useAIQuota();
  return usage?.status === AI_QUOTA_USAGE_STATUS.EXHAUSTED;
}

export default useIsAIQuotaExhausted;
